import { ApiRequestService } from './api-request.service';
import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';
import { AppData } from '..';
// import { Firebase } from '@ionic-native/fiappmoebase/ngx';
// import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { FirebaseX } from '@ionic-native/firebase-x/ngx';
import { AnalyticsService } from './analytics.service';
import { CLEVER_TAP_EVENT } from 'src/app/core/constants/clever-tab-event-constants';
import { allowBlockNotificationEvent } from '../utils/clever-tab-functions';

declare var cordova;
@Injectable({
  providedIn: 'root'
})
export class FcmMessagingService {

  allowNotification = false;

  constructor(private storage: StorageService,
    private apiRequestService: ApiRequestService,
    //private fcm: FCM
    // private firebase: Firebase
    private firebaseX: FirebaseX,
    private analyticsService: AnalyticsService
  ) {
    console.log('FcmMessagingService init');
    // this.getFCMToken();
  }

  getFCMToken() {
    this.firebaseX.getToken().then(token => {
        console.log('FCM Token: ' + token);
        AppData.fcmTokenSub$.next(token);
        AppData.fcmToken = token;
  
        if (AppData.userInfoData !== undefined && AppData.userInfoData !== null) {
          this.sendFCMTokenToServer();
        }
      });
  }

  async tokenSubscribe() {
    await this.checkPermission();
    await this.getFCMToken();
  }

  checkPermission() {
    this.firebaseX.hasPermission().then(async hasPermission => {
      console.log('permission grant checked');
      this.allowNotification = hasPermission ? true : false;
      if (!hasPermission) {
        await this.firebaseX.grantPermission().then(res => {
          this.allowNotification = true;
          console.log(res);
          console.log('permission granted');
        }).catch(err => {
          console.log(err);
        });
      }
      this.blockNotificationEvent();
    })

  }

  blockNotificationEvent () {
    this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.ALLOW_BLOCK_NOTIFICATION, allowBlockNotificationEvent(this.allowNotification));
  }

  onNotifications() {
    return this.firebaseX.onMessageReceived();
  }

  async sendFCMTokenToServer() {
    console.log(' sendFCMTokenToServer API Called');
    const body = {
      'newToken': AppData.fcmToken,
      'userId': AppData.userInfoData['userId']
    }
    this.apiRequestService.patch('sendFCMToken', '', body);
  }
}
